module.exports = __webpack_public_path__ + "static/img/icon-chahua.cb86a4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-chahua.png
// module id = 3FSl
// module chunks = 1